<script lang="ts">
  import Tailwind from './Tailwind.svelte';
  import Header from './Header.svelte';
  import Jumbotron from './Jumbotron.svelte';
  import Skills from './Skills.svelte';
  import Education from './Education.svelte';
  import Experience from './Experience.svelte';
</script>

<Tailwind />
<Header />
<main class="p-3 md:p-8 print:p-4">
  <Jumbotron />
  <Skills />
  <Education />
  <Experience />
</main>

<style global lang="postcss">
  section hr {
    @apply mt-0 mb-2;
    border-color: darkgrey;
  }

  @media print {
    @page {
      size: A4;
      margin: 0.5in;
    }

    * {
      @apply text-xs;
    }
    :global(.web-only) {
      display: none;
    }
    section {
      @apply my-1;
    }
    section hr {
      @apply mt-0 mb-1;
    }
    body {
      margin: 0;
      padding: 0;
    }
    main {
      max-width: none;
      margin: 0;
    }
    h1,
    h2,
    h3,
    h4 {
      page-break-after: avoid;
    }
    li {
      page-break-inside: avoid;
    }
  }
</style>
